import { useEffect, useState } from 'react'
import { MdSearch } from 'react-icons/md'
import { useHistory } from 'react-router-dom'
import { getEmployers } from '../../../../API/Analytics/employers'
import { getAssetsCompany } from '../../../../API/Services/Company/Company'
import { useIntl } from 'react-intl'
import { translate } from '../../../../i18n/Library/hierarchicalLevel'

import './menuColaboradores.sass'
import { getEmployeesURL } from '../../../../API/Employee/Employee'

const img = 'https://assets.mydna.company/profile-placeholder.png'

const REGEX_ID = /(([\s\S])+[^\d+$])/g

const MenuColaboradores = ({ logo = true, analytics = true, handleEmployee, employeeId, employeeList, overflow = true }) => {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	const companyId = JSON.parse(localStorage.getItem('user')).id
	const token = localStorage.getItem('token')
	const [employeeImages, setEmployeeImages] = useState([])

	const [employers, setEmployers] = useState([])
	const [imgCompany, setImgCompany] = useState([])
	const [list, setList] = useState(employers)
	const [search, setSearch] = useState('')

	const history = useHistory()
	const pathName = history.location.pathname
	const EmployeeID = pathName.replace(REGEX_ID, '')

	const handleChange = event => {
		setSearch(event.currentTarget.value)
	}

	useEffect(() => {
		const newList = employers?.filter(colaborador => {
			return colaborador.name.toLowerCase().includes(search.toLowerCase())
		})
		setList(newList)
	}, [search, employers])

	useEffect(() => {
		if (analytics) {
			const fetchEmployers = async () => {
				const employeeImages = await getEmployeesURL(companyId, token)
				setEmployeeImages(employeeImages)
				const company = JSON.parse(localStorage.getItem('user'))
				setEmployers(await getEmployers(company.id))
				const imgCAux = await getAssetsCompany(company.id)
				setImgCompany(imgCAux[imgCAux.length - 1]?.url)
			}
			fetchEmployers()
		} else {
			setEmployers(employeeList)
		}
	}, [employeeList, analytics])

	const handleClick = id => {
		if (analytics) {
			history.push(`/app/analytic/perfil/${id}`)
		}
		handleEmployee(id)
	}

	return (
		<div className={`menu-colaboradores ${overflow ?? `overflow-auto`}`}>
			{logo && (
				<div className='menu-industry'>
					<img
						src={
							imgCompany ||
							'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpLotRL0OYMLOnUTpIxP6nouw7U6KZ7HuAFe4729r3W4WaWo9EctFWBMaMnBiIDPfcetQ&usqp=CAU'
						}
						className='img-fluid rounded-circle border p-1'
						alt=''
						onError={e => {
							e.target.src = 'https://assets.mydna.company/b2b-images/no-avatar.png'
						}}
					/>
				</div>
			)}
			<h6 className='fw-bold'>
				Colaboradores <text className='text-muted tw-text-gray-400  tw-ml-3'> {employers?.length} </text>
			</h6>
			<div className='border tw-rounded-2xl tw-p-2 tw-flex tw-items-center'>
				<MdSearch size={22} className='tw-text-gray-500' />
				<input
					type='text'
					value={search}
					placeholder='Buscar colaborador...'
					onChange={handleChange}
					className='tw-outline-none border-0 tw-p-0 tw-my-0 m-0 tw-w-full tw-text-sm tw-text-gray-700 placeholder-gray-400'
				/>
			</div>
			<ul>
				{[...list]
					?.sort((a, b) => a.name.localeCompare(b.name))
					.map(colaborador => (
						<li
							key={colaborador.id}
							className={Number(colaborador.id) === Number(EmployeeID) || Number(colaborador.id) === Number(employeeId) ? 'active' : ''}
							onClick={() => handleClick(colaborador.id)}
						>
							<img
								src={
									employeeImages.find(img => img.mydnaUserEmail === colaborador.email)?.url || 'https://assets.mydna.company/profile-placeholder.png'
								}
								alt=''
							/>
							<div className='text'>
								<h6>{colaborador.name}</h6>
								<span>{translate[language][colaborador.level?.PositionN] || translate[language][colaborador?.employeeLevel?.level]}</span>
							</div>
						</li>
					))}
			</ul>
		</div>
	)
}

export default MenuColaboradores
